import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'This is a required field' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'This is a required field' }
      ]
    },
    addressline1: {
      validations: [
        { type: 'required', message: 'This is a required field' }

      ]
    },
    city: {
      validations: [
        { type: 'required', message: 'This is a required field' }

      ]
    },
    state: {
      validations: [
        { type: 'required', message: 'This is a required field' }

      ]
    },
    postal: {
      validations: [
        { type: 'required', message: 'This is a required field' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'This is a required field' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' }
      ]
    },
    telNumber: {
      validations: [
        { type: 'required', message: 'This is a required field' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' }
      ]
    },
    reference: {
      validations: [
        { type: 'required', message: 'This is a required field' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'This is a required field' },
        { type: 'dateinfuture', message: 'Event date must be in the future.' }
      ]
    },
    eventextra1: {
      validations: []
    },
    eventextra2: {
      validations: [
        { type: 'required', message: 'This is a required field' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'This is a required field' }
      ]
    },
    eventextra3: {
      validations: [
        { type: 'required', message: 'This is a required field' }
      ]
    },   
    eventextra4: {
      validations: [
        { type: 'required', message: 'This is a required field' }
      ]
    },
    eventextra5: {
      validations: [
        { type: 'required', message: 'This is a required field' }
      ]
    },
    eventextra6: {
      validations: []
    },
    eventextra7: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'label',
            size: 'Medium',
            label: 'Fields marked with an * are required',
            mapping: 'headerLabel',
            customClasses: ['header']
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'firstName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address 1 *',
            mapping: 'addressline1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City *',
            mapping: 'city'
          },
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State *',
            options: [
              { label: 'New York', value: 'NY' },
              { label: 'Alabama', value: 'AL' },
              { label: 'Alaska', value: 'AK' },
              { label: 'Arizona', value: 'AZ' },
              { label: 'Arkansas', value: 'AR' },
              { label: 'American Somoa', value: 'AS' },              
              { label: 'California', value: 'CA' },
              { label: 'Colorado', value: 'CO' },
              { label: 'Connecticut', value: 'CT' },
              { label: 'Delaware', value: 'DE' },
              { label: 'District of Columbia', value: 'DC' },
              { label: 'Florida', value: 'FL' },
              { label: 'Georgia', value: 'GA' },
              { label: 'Hawaii', value: 'HI' },
              { label: 'Idaho', value: 'ID' },
              { label: 'Illinois', value: 'IL' },
              { label: 'Indiana', value: 'IN' },
              { label: 'Iowa', value: 'IA' },
              { label: 'Kansas', value: 'KS' },
              { label: 'Kentucky', value: 'KY' },
              { label: 'Louisiana', value: 'LA' },
              { label: 'Maine', value: 'ME' },
              { label: 'Maryland', value: 'MD' },
              { label: 'Massachusetts', value: 'MA' },
              { label: 'Michigan', value: 'MI' },
              { label: 'Minnesota', value: 'MN' },
              { label: 'Mississippi', value: 'MS' },
              { label: 'Missouri', value: 'MO' },
              { label: 'Northern Mariana Islands', value: 'NMI' },
              { label: 'Montana', value: 'MT' },
              { label: 'National', value: 'National' },
              { label: 'Nebraska', value: 'NE' },
              { label: 'Nevada', value: 'NV' },
              { label: 'New Hampshire', value: 'NH' },
              { label: 'New Jersey', value: 'NJ' },
              { label: 'New Mexico', value: 'NM' },
              { label: 'North Carolina', value: 'NC' },
              { label: 'North Dakota', value: 'ND' },
              { label: 'Ohio', value: 'OH' },
              { label: 'Oklahoma', value: 'OK' },
              { label: 'Oregon', value: 'OR' },
              { label: 'Pennsylvania', value: 'PA' },
              { label: 'Puerto Rico', value: 'PR' },
              { label: 'Rhode Island', value: 'RI' },
              { label: 'South Carolina', value: 'SC' },
              { label: 'South Dakota', value: 'SD' },
              { label: 'Tennessee', value: 'TN' },
              { label: 'Texas', value: 'TX' },
              { label: 'Utah', value: 'UT' },
              { label: 'Vermont', value: 'VT' },
              { label: 'Virginia', value: 'VA' },
              { label: 'Virgin Islands', value: 'VI' },
              { label: 'Washington', value: 'WA' },
              { label: 'West Virginia', value: 'WV' },
              { label: 'Wisconsin', value: 'WI' },
              { label: 'Wyoming', value: 'WY' }
            ],
            mapping: 'state'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip / Post Code *',
            mapping: 'postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone *',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'How did you hear about us? *',
            mapping: 'reference'
          },
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date *',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Fiance\' Name',
            mapping: 'eventextra1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Current Package *',
            options: [
              { label: 'Default' , value: 'Default'}
            ],
            mapping: 'eventextra2'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests - Minimum Guest Count is 60 *',
            mapping: 'plannedguestcount'
          }
        ]
      },   
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'What services would you like to use the venue for? Select at most one ceremony and one reception. *',
            options: [
              { label: 'Wedding Reception' , value: 'Wedding Reception'},
              { label: 'Wedding Ceremony & Reception', value: 'Wedding Ceremony & Reception'},
              { label: 'Wedding Ceremony ONLY', value: 'Wedding Ceremony ONLY'}
            ],
            mapping: 'eventextra3'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Which season are you planning to have your event? *',
            options: [
              { label: 'On peak (April to November)' , value: 'On peak (April to November)'},
              { label: 'Off peak (December to March)', value: 'Off peak (December to March)'}
            ],
            mapping: 'eventextra4'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Which day of the week would you like to hold the event? *',
            options: [
              { label: 'Tuesday - Thursday' , value: 'Tuesday - Thursday'},
              { label: 'Sunday or Saturday Daytime', value: 'Sunday or Saturday Daytime'},
              { label: 'Friday Evening' , value: 'Friday Evening'},
              { label: 'Saturday Evening', value: 'Saturday Evening'}
            ],
            mapping: 'eventextra5'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Would you like Up Lighting',
            options: [
              { label: 'Yes' , value: 'Yes'},
              { label: 'No', value: 'No'}
            ],
            mapping: 'eventextra6'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Would you like Chair Covers 60+ Colors',
            options: [
              { label: 'Yes' , value: 'Yes'},
              { label: 'No', value: 'No'}
            ],
            mapping: 'eventextra7'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'GET PRICE!'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Antun\'s Of Queens Wedding Planner Form',
    formId: '348',
    clientKey: 'B5EEC117-B87E-42EA-B33D-09FAD41EB125',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// c:/_Development/Web Inquiry/inquiry-renderer/client_forms/antuns1/form_structure.js